export const CSV_INFORMATION_UI = {
  CSV_INFORMATION_UI_SET_SELECTED: "CSV_INFORMATION_UI_SET_SELECTED",
  CSV_INFORMATION_UI_CLEAR_SELECTED: "CSV_INFORMATION_UI_CLEAR_SELECTED",
};
